
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0872ddb5&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PendingManagement.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PendingManagement.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0872ddb5!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PendingManagement.vue"),
  /* scopeId */
  "data-v-0872ddb5",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dashboard/PendingManagement.vue
// module id = 623
// module chunks = 0